import {
  TextField,
  FunctionField,
} from 'react-admin'
import DatagridWithSubtotals from '../../custom/datagrid-with-subtotals'
import {
  useLabel,
  usePayRollupTickets,
  useTranslateResource,
} from '../../../hooks'
import DriverPayroll from '../../shared/driver-payroll'
import { NumberField, CurrencyField, DateField } from '../../custom'

const TicketsGrid = ({
  record: {
    tonnage_tickets: tonnageTickets,
    hourly_tickets: hourlyTickets,
  }
}) => {
  const resource = 'driver_pay_rollup_tickets'
  const label = useLabel({ resource })
  const translate = useTranslateResource(resource, 'lines')

  const { collection, conditionallyVisibleFields } = usePayRollupTickets({ tonnageTickets, hourlyTickets})
  return (
    <DatagridWithSubtotals
      data={collection}
    >
      <DateField source='date' label={label('date')} />
      <TextField source='ticket_number' label={label('ticket_number')} />
      { conditionallyVisibleFields.includes('net_weight_in_tons') && <NumberField source='net_weight_in_tons' label={label('net_weight_in_tons')} /> }
      { conditionallyVisibleFields.includes('tonnage_pay_rate_in_dollars') && <CurrencyField source='tonnage_pay_rate_in_dollars' label={label('tonnage_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('tonnage_pay_rate_in_dollars') && <FunctionField render={record => record.is_flat_base_rate ? translate('flat_rate') : null} label={''} cellSx={{ paddingLeft: 0 }} /> }
      { conditionallyVisibleFields.includes('equipment_rate_in_dollars') && <CurrencyField source='equipment_rate_in_dollars' label={label('equipment_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('equipment_rate_in_dollars') && <FunctionField render={record => record.is_flat_equipment_rate ? translate('flat_rate') : null} label={''} cellSx={{ paddingLeft: 0 }} /> }
      { conditionallyVisibleFields.includes('haul_time_in_hours') && <NumberField source='haul_time_in_hours' label={label('haul_time_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('haul_pay_rate_in_dollars') && <CurrencyField source='haul_pay_rate_in_dollars' label={label('haul_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('convey_time_in_hours') && <NumberField source='convey_time_in_hours' label={label('convey_time_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('convey_pay_rate_in_dollars') && <CurrencyField source='convey_pay_rate_in_dollars' label={label('convey_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('equipment_time_in_hours') && <NumberField source='equipment_time_in_hours' label={label('equipment_time_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('equipment_pay_rate_in_dollars') && <CurrencyField source='equipment_pay_rate_in_dollars' label={label('equipment_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('wait_time_in_hours') && <NumberField source='wait_time_in_hours' label={label('wait_time_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('wait_pay_rate_in_dollars') && <CurrencyField source='wait_pay_rate_in_dollars' label={label('wait_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('regular_time_in_hours') && <NumberField source='regular_time_in_hours' label={label('regular_time_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('regular_pay_rate_in_dollars') && <CurrencyField source='regular_pay_rate_in_dollars' label={label('regular_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('overtime_in_hours') && <NumberField source='overtime_in_hours' label={label('overtime_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('overtime_pay_rate_in_dollars') && <CurrencyField source='overtime_pay_rate_in_dollars' label={label('overtime_pay_rate_in_dollars')} forceZero /> }
      { conditionallyVisibleFields.includes('doubletime_in_hours') && <NumberField source='doubletime_in_hours' label={label('doubletime_in_hours')} forceZero /> }
      { conditionallyVisibleFields.includes('doubletime_pay_rate_in_dollars') && <CurrencyField source='doubletime_pay_rate_in_dollars' label={label('doubletime_pay_rate_in_dollars')} /> }
      { conditionallyVisibleFields.includes('fuel_surcharge_in_dollars') && <CurrencyField source='fuel_surcharge_in_dollars' label={label('fuel_surcharge_in_dollars')} forceZero /> }
      { conditionallyVisibleFields.includes('fuel_surcharge_in_dollars') && <FunctionField render={record => record.is_flat_fuel_surcharge ? translate('flat_rate') : null} label={''} cellSx={{ paddingLeft: 0 }} /> }
      { conditionallyVisibleFields.includes('material_surcharge_in_dollars') && <CurrencyField source='material_surcharge_in_dollars' label={label('material_surcharge_in_dollars')} forceZero /> }
      { conditionallyVisibleFields.includes('material_surcharge_in_dollars') && <FunctionField render={record => record.is_flat_material_surcharge ? translate('flat_rate') : null} label={''} cellSx={{ paddingLeft: 0 }} /> }
      <NumberField source='total_pay_in_dollars' label={label('total_pay_in_dollars')} forceZero />
    </DatagridWithSubtotals>
  )
}

const BrokerDriverPayroll = ({ record }) => {
  const {
    total_in_dollars,
    tenant,
    period: { end_date: date },
  } = record

  return (
    <DriverPayroll
      tenant={tenant}
      date={date}
      total={total_in_dollars}
      lineItems={<TicketsGrid record={record} />}
    />
  )
}

export default BrokerDriverPayroll
